import { useNavigate } from 'react-router-dom';
import { Article, stepInfo } from '../../../mocks/articles';

interface RelatedArticlesProps {
  currentArticleId: number;
  currentStep: string;
  allArticles: Article[];
}

export default function RelatedArticles({ currentArticleId, currentStep, allArticles }: RelatedArticlesProps) {
  const navigate = useNavigate();
  const related = allArticles
    .filter((a) => a.step === currentStep && a.id !== currentArticleId)
    .slice(0, 3);

  if (related.length === 0) return null;

  const step = stepInfo[currentStep];

  return (
    <aside className="mt-12 pt-10 border-t border-[#EAE4DC]" aria-labelledby="related-heading">
      <div className="flex items-center gap-2 mb-6">
        <span
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold"
          style={{ backgroundColor: step?.bgColor, color: step?.color }}
        >
          <i className={step?.icon} aria-hidden="true" />
          STEP {currentStep}
        </span>
        <h3 id="related-heading" className="text-base font-bold text-[#2C2C2C]">関連記事</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {related.map((article) => (
          <article key={article.id} className="group">
            <a
              href={`/articles/${article.id}`}
              onClick={(e) => { e.preventDefault(); navigate(`/articles/${article.id}`); }}
              className="block bg-white rounded-xl overflow-hidden hover:-translate-y-0.5 transition-transform duration-200 no-underline"
              aria-label={article.title}
            >
              <div className="w-full h-36 overflow-hidden bg-[#EDEAE6]">
                <img
                  src={article.image}
                  alt={article.title}
                  loading="lazy"
                  decoding="async"
                  width="320"
                  height="144"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <p className="text-[#A0A0A0] text-[10px] mb-1.5">
                  <time dateTime={article.date}>{article.date}</time>
                  {' '}・{' '}{article.readTime}
                </p>
                <h4 className="text-[#2C2C2C] text-xs font-bold leading-snug line-clamp-2 group-hover:text-[#8FA882] transition-colors">
                  {article.title}
                </h4>
                <span className="inline-flex items-center gap-1 text-[#8FA882] text-[10px] font-semibold mt-2">
                  続きを読む
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </div>
            </a>
          </article>
        ))}
      </div>
    </aside>
  );
}
